export default __webpack_public_path__ + "static/media/streamer_avatar8.1f8ee5e5.png";